const settlementsData = [
    {
        "key": "4901",
        "value": "Rokovci",
        "jls": "Andrijaševci"
    },
    {
        "key": "14",
        "value": "Andrijaševci",
        "jls": "Andrijaševci"
    },
    {
        "key": "35",
        "value": "Babina Greda",
        "jls": "Babina Greda"
    },
    {
        "key": "4221",
        "value": "Petrovci",
        "jls": "Bogdanovci"
    },
    {
        "key": "322",
        "value": "Bogdanovci",
        "jls": "Bogdanovci"
    },
    {
        "key": "5513",
        "value": "Svinjarevci",
        "jls": "Bogdanovci"
    },
    {
        "key": "369",
        "value": "Borovo",
        "jls": "Borovo"
    },
    {
        "key": "378",
        "value": "Bošnjaci",
        "jls": "Bošnjaci"
    },
    {
        "key": "692",
        "value": "Cerna",
        "jls": "Cerna"
    },
    {
        "key": "5605",
        "value": "Šiškovci",
        "jls": "Cerna"
    },
    {
        "key": "4317",
        "value": "Posavski Podgajci",
        "jls": "Drenovci"
    },
    {
        "key": "4742",
        "value": "Rajevo Selo",
        "jls": "Drenovci"
    },
    {
        "key": "4691",
        "value": "Račinovci",
        "jls": "Drenovci"
    },
    {
        "key": "1306",
        "value": "Drenovci",
        "jls": "Drenovci"
    },
    {
        "key": "1435",
        "value": "Đurići",
        "jls": "Drenovci"
    },
    {
        "key": "1956",
        "value": "Gradište",
        "jls": "Gradište"
    },
    {
        "key": "2029",
        "value": "Gunja",
        "jls": "Gunja"
    },
    {
        "key": "3670",
        "value": "Mohovo",
        "jls": "Ilok"
    },
    {
        "key": "5532",
        "value": "Šarengrad",
        "jls": "Ilok"
    },
    {
        "key": "98",
        "value": "Bapska",
        "jls": "Ilok"
    },
    {
        "key": "2149",
        "value": "Ilok",
        "jls": "Ilok"
    },
    {
        "key": "4614",
        "value": "Prkovci",
        "jls": "Ivankovo"
    },
    {
        "key": "4851",
        "value": "Retkovci",
        "jls": "Ivankovo"
    },
    {
        "key": "2188",
        "value": "Ivankovo",
        "jls": "Ivankovo"
    },
    {
        "key": "2265",
        "value": "Jarmina",
        "jls": "Jarmina"
    },
    {
        "key": "3980",
        "value": "Opatovac",
        "jls": "Lovas"
    },
    {
        "key": "3173",
        "value": "Lovas",
        "jls": "Lovas"
    },
    {
        "key": "1508",
        "value": "Gaboš",
        "jls": "Markušica"
    },
    {
        "key": "2445",
        "value": "Karadžićevo",
        "jls": "Markušica"
    },
    {
        "key": "3491",
        "value": "Markušica",
        "jls": "Markušica"
    },
    {
        "key": "4048",
        "value": "Ostrovo",
        "jls": "Markušica"
    },
    {
        "key": "4367",
        "value": "Podrinje",
        "jls": "Markušica"
    },
    {
        "key": "3781",
        "value": "Negoslavci",
        "jls": "Negoslavci"
    },
    {
        "key": "3795",
        "value": "Nijemci",
        "jls": "Nijemci"
    },
    {
        "key": "27",
        "value": "Apševci",
        "jls": "Nijemci"
    },
    {
        "key": "1120",
        "value": "Donje Novo Selo",
        "jls": "Nijemci"
    },
    {
        "key": "1423",
        "value": "Đeletovci",
        "jls": "Nijemci"
    },
    {
        "key": "3122",
        "value": "Lipovac",
        "jls": "Nijemci"
    },
    {
        "key": "4341",
        "value": "Podgrađe",
        "jls": "Nijemci"
    },
    {
        "key": "5572",
        "value": "Banovci",
        "jls": "Nijemci"
    },
    {
        "key": "6111",
        "value": "Vinkovački Banovci",
        "jls": "Nijemci"
    },
    {
        "key": "678",
        "value": "Cerić",
        "jls": "Nuštar"
    },
    {
        "key": "3921",
        "value": "Nuštar",
        "jls": "Nuštar"
    },
    {
        "key": "3467",
        "value": "Marinci",
        "jls": "Nuštar"
    },
    {
        "key": "4068",
        "value": "Otok",
        "jls": "Otok"
    },
    {
        "key": "2631",
        "value": "Komletinci",
        "jls": "Otok"
    },
    {
        "key": "4608",
        "value": "Privlaka",
        "jls": "Privlaka"
    },
    {
        "key": "5116",
        "value": "Slakovci",
        "jls": "Stari Jankovci"
    },
    {
        "key": "5251",
        "value": "Srijemske Laze",
        "jls": "Stari Jankovci"
    },
    {
        "key": "3864",
        "value": "Novi Jankovci",
        "jls": "Stari Jankovci"
    },
    {
        "key": "4024",
        "value": "Orolik",
        "jls": "Stari Jankovci"
    },
    {
        "key": "5309",
        "value": "Stari Jankovci",
        "jls": "Stari Jankovci"
    },
    {
        "key": "5313",
        "value": "Stari Mikanovci",
        "jls": "Stari Mikanovci"
    },
    {
        "key": "3869",
        "value": "Novi Mikanovci",
        "jls": "Stari Mikanovci"
    },
    {
        "key": "5654",
        "value": "Štitar",
        "jls": "Štitar"
    },
    {
        "key": "3606",
        "value": "Mikluševci",
        "jls": "Tompojevci"
    },
    {
        "key": "1923",
        "value": "Grabovo",
        "jls": "Tompojevci"
    },
    {
        "key": "790",
        "value": "Čakovci",
        "jls": "Tompojevci"
    },
    {
        "key": "208",
        "value": "Berak",
        "jls": "Tompojevci"
    },
    {
        "key": "338",
        "value": "Bokšić",
        "jls": "Tompojevci"
    },
    {
        "key": "5739",
        "value": "Tompojevci",
        "jls": "Tompojevci"
    },
    {
        "key": "5758",
        "value": "Tordinci",
        "jls": "Tordinci"
    },
    {
        "key": "2694",
        "value": "Korog",
        "jls": "Tordinci"
    },
    {
        "key": "17",
        "value": "Antin",
        "jls": "Tordinci"
    },
    {
        "key": "3657",
        "value": "Mlaka Antinska",
        "jls": "Tordinci"
    },
    {
        "key": "5762",
        "value": "Tovarnik",
        "jls": "Tovarnik"
    },
    {
        "key": "2147",
        "value": "Ilača",
        "jls": "Tovarnik"
    },
    {
        "key": "303",
        "value": "Bobota",
        "jls": "Trpinja"
    },
    {
        "key": "562",
        "value": "Bršadin",
        "jls": "Trpinja"
    },
    {
        "key": "883",
        "value": "Ćelije",
        "jls": "Trpinja"
    },
    {
        "key": "3214",
        "value": "Ludvinci",
        "jls": "Trpinja"
    },
    {
        "key": "4088",
        "value": "Pačetin",
        "jls": "Trpinja"
    },
    {
        "key": "5818",
        "value": "Trpinja",
        "jls": "Trpinja"
    },
    {
        "key": "6071",
        "value": "Vera",
        "jls": "Trpinja"
    },
    {
        "key": "3640",
        "value": "Mirkovci",
        "jls": "Vinkovci"
    },
    {
        "key": "6112",
        "value": "Vinkovci",
        "jls": "Vinkovci"
    },
    {
        "key": "6175",
        "value": "Vođinci",
        "jls": "Vođinci"
    },
    {
        "key": "5200",
        "value": "Soljani",
        "jls": "Vrbanja"
    },
    {
        "key": "5391",
        "value": "Strošinci",
        "jls": "Vrbanja"
    },
    {
        "key": "6228",
        "value": "Vrbanja",
        "jls": "Vrbanja"
    },
    {
        "key": "6612",
        "value": "Grabovo-dio (Ovčara, Jakobovac)",
        "jls": "Vukovar"
    },
    {
        "key": "5212",
        "value": "Sotin",
        "jls": "Vukovar"
    },
    {
        "key": "6324",
        "value": "Vukovar",
        "jls": "Vukovar"
    },
    {
        "key": "3128",
        "value": "Lipovača",
        "jls": "Vukovar"
    },
    {
        "key": "6590",
        "value": "Županja",
        "jls": "Županja"
    }
]
export default settlementsData;
